const localUrl = {
  getQueryString: function(name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    let r = window.location.search.substr(1).match(reg);
    if (r !== null) return unescape(r[2]);
    return null;
  },
  toLogin: function() {
    window.location.href =
      '/user/login?city=145' +
      '&returnUrl=' +
      encodeURIComponent(window.location.href);
  },
};

export default localUrl;
